import * as io from "io-ts";
import type { Project } from "../../api/useProjects";

const FilteredValuesByFilterType = io.strict({
  sourceId: io.array(io.string),
  type: io.array(io.string),
  site: io.array(io.string),
});

export type FilteredValuesByFilterType = io.TypeOf<typeof FilteredValuesByFilterType>;

export const DEFAULT_PROJECT_FILTER_VALUES: FilteredValuesByFilterType = {
  sourceId: [],
  type: [],
  site: [],
};

export function filterProjects(
  projects: Project[],
  { type: typeIds, site: siteIds, sourceId: sourceIds }: FilteredValuesByFilterType,
) {
  return sourceIds.length + siteIds.length + typeIds.length === 0
    ? projects
    : projects
        .filter(p => typeIds.length === 0 || (p.typeId && typeIds.includes(p.typeId)))
        .filter(p => siteIds.length === 0 || (p.siteId && siteIds.includes(p.siteId)))
        .filter(p => sourceIds.length === 0 || sourceIds.includes(p.sourceId));
}
